export default "__VITE_ASSET__CjOCWoP3__"